import type { MetaFunction } from "@remix-run/cloudflare";
import { Link } from "@remix-run/react";
import Footer from "~/components/Footer";
import { posts } from "~/lib/blog-data";
import { useScrollReveal } from "~/lib/use-scroll-reveal";
import styles from "~/styles/blog.module.css";

export const meta: MetaFunction = () => [
  { title: "Blog — Prodigium Dynamics" },
  { name: "description", content: "Insights on AI-driven products, reading technology, digital publishing, and the science of building things that matter." },
];

export default function BlogPage() {
  const [featured, ...rest] = posts;

  useScrollReveal();

  return (
    <>
      <section className={styles.hero}>
        <div>
          <p className={styles.heroLabel}>Blog</p>
          <h1 className={styles.heroTitle}>SIGNAL<br />OVER<br />NOISE.</h1>
        </div>
        <div className={styles.heroRight}>
          <p className={styles.heroSub}>
            Insights on reading technology, AI systems, and the science of building things that matter.
            Published when there&apos;s something worth saying.
          </p>
          <div className={styles.categories}>
            {["All", "Technology", "Reading", "Learning", "Science", "Product"].map((c) => (
              <span key={c} className={`${styles.catBtn} ${c === "All" ? styles.catBtnActive : ""}`}>{c}</span>
            ))}
          </div>
        </div>
      </section>

      <div className="rule" />

      <div className={`${styles.featured} reveal`}>
        <p className={styles.featuredLabel}>Featured</p>
        <div className={styles.featuredInner}>
          <div className={styles.featuredImage}>
            <span className={styles.featuredImageText}>{featured.title.split("\n")[0]}</span>
          </div>
          <div>
            <p className={styles.postTag}>{featured.category}</p>
            <h2 className={styles.postTitle}>{featured.title.replace("\n", " ")}</h2>
            <p className={styles.postExcerpt}>{featured.lead.slice(0, 180)}…</p>
            <div className={styles.postMeta}>
              <span>{featured.date}</span>
              <span>{featured.readTime}</span>
            </div>
            <Link to={`/blog/${featured.slug}`} className={styles.postLink}>
              Read article →
            </Link>
          </div>
        </div>
      </div>

      <div className="rule" />

      <div className={styles.postsSection}>
        <p className={styles.postsGridLabel}>All articles</p>
        <div className={styles.postsGrid}>
          {rest.map((post, i) => (
            <article key={post.slug} className={`${styles.postCard} reveal`} style={{ transitionDelay: `${i * 80}ms` }}>
              <p className={styles.postTag}>{post.category}</p>
              <h3 className={styles.postTitle}>{post.title.replace("\n", " ")}</h3>
              <p className={styles.postExcerpt}>{post.lead.slice(0, 140)}…</p>
              <div className={styles.postMeta}>
                <span>{post.date}</span>
                <span>{post.readTime}</span>
              </div>
              <Link to={`/blog/${post.slug}`} className={styles.postLink}>Read →</Link>
            </article>
          ))}
          <div className={`${styles.postCard} ${styles.postCardComing}`}>
            <p className={styles.comingLabel}>More articles<br />in progress</p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
